import React from 'react';
import image1 from '../../assests/images/image_premium1.png';
import image2 from '../../assests/images/image_premium2.png'
import image3 from '../../assests/images/image_premium3.png'
import GroupIcon from '@mui/icons-material/Group';
import DeleteIcon from '@mui/icons-material/Delete';
import imgRedSec from '../../assests/images/red_ico_sec.png'
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faCoffee, faCreditCard, faLocationDot, faCar, faRoad } from '@fortawesome/free-solid-svg-icons';

const WeOffer = () => {
    let arr = [
        {
            id: 1,
            icon: faCreditCard,
            head_name: "Flexible Payment ",
            info_card: "We offer a hassle-free service: pay in-person, in-app or pre-pay online. "
        },
        {
            id: 2,
            icon: faCreditCard,
            head_name: "Full-Service Transportation",
            info_card: "Metro 24 x 7 is an easy way to travel to/from the airport anywhere in the UK. "

        },
        {
            id: 3,
            icon: faLocationDot,
            head_name: "24/7 Booking Services",
            info_card: "Book our ride anytime. Our Stansted airport transfers representatives are available 24/7. "

        },
        {
            id: 4,
            icon: faCar,
            head_name: "25 Year’s Experience ",
            info_card: "Our years of ride-hailing services experience facilitate us to recognise and understand our clients’ needs."

        },

        {
            id: 5,
            icon: faCar,
            head_name: "Economical Rates ",
            info_card: "Our customer trusts us because of our low rates, professional employees and excellent service. "

        },
        // {
        //     id: 6,
        //     icon: faRoad,
        //     head_name: "Long Distance",
        //     info_card: "Curabitur placerat cursus nisi nec pharetra. Proin quis tortor fringilla, placerat nisi nec, auctor ex. Donec commodo . "

        // },
        // {
        //     id: 7,
        //     icon: faCreditCard,
        //     head_name: "Manage Your Booking",
        //     info_card: "Curabitur placerat cursus nisi nec pharetra. Proin quis tortor fringilla, placerat nisi nec, auctor ex. Donec commodo . "

        // },
    ];
    return (
        <div>
            <div className='container'>
                <div className="row"><div className="col-lg-12 text-center mb-4">
                    <p className="red-clr f-16 lh-1 mt-5 mb-2 f-pop-bold">
                        Why Choose Us?
                    </p>
                    <p className="blu-clr-book f-40 lh-1 mb-2 text-white f-pop-med">
                        We Offer Easy Booking and Reliable Services
                    </p>
                </div>
                </div>
                <div className='d-flx-blue'>
                    {arr.map((item, i) => {
                        return (
                            <div key={i} className='card border-0 h-100 card-custm-blue'>
                                <div className='card-body pb-0'>
                                    <div className='ico_blue_home m-auto'> <FontAwesomeIcon className='font-ico-blu-sec' icon={item.icon} /></div>
                                    <p className='f-16 mt-3 mb-3 on-pay f-pop-semibold'>{item.head_name}</p>
                                    <p className='f-12 lh-2 pb-2 brdr-btm-purp clr_easy_p on-pay f-pop-med'>{item.info_card}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default WeOffer;